import {
  canUseProductionAutomation,
} from '../../utils/productionAccess.js';

export const VIDEO_PRODUCTION_CREATE_PATH = '/automation/video-editing/create';
export const VIDEO_PRODUCTION_ORDER_ID_PARAM = 'orderId';
export const VIDEO_PRODUCTION_JOBS_PATH = '/automation/video-editing/list';
export const VIDEO_PRODUCTION_JOB_ID_PARAM = 'jobId';

export const canUseVideoProductionEntry = (role) =>
  canUseProductionAutomation(role);

export const shouldShowVideoProductionButton = ({ role, automation } = {}) =>
  canUseVideoProductionEntry(role) && automation?.supported === true;

export const getReviewActionLabel = ({ role, label, action } = {}) => {
  if (
    canUseVideoProductionEntry(role) &&
    (action === 'NavigateToOnlyViewPage' || label === '详情页')
  ) {
    return '制作';
  }
  return label;
};

export const buildVideoProductionCreatePath = (orderId) => {
  const params = new URLSearchParams();
  params.set(VIDEO_PRODUCTION_ORDER_ID_PARAM, String(orderId || ''));
  return `${VIDEO_PRODUCTION_CREATE_PATH}?${params.toString()}`;
};

export const buildVideoProductionJobsPath = (jobId) => {
  if (jobId === undefined || jobId === null || jobId === '') {
    return VIDEO_PRODUCTION_JOBS_PATH;
  }

  const params = new URLSearchParams();
  params.set(VIDEO_PRODUCTION_JOB_ID_PARAM, String(jobId));
  return `${VIDEO_PRODUCTION_JOBS_PATH}?${params.toString()}`;
};
